import { classicSkinPack } from './classicSkin';
import type { SkinPack, SpriteDef } from './types';

const skinPacks: Record<string, SkinPack> = {
  [classicSkinPack.id]: classicSkinPack,
};

export function registerSkinPack(pack: SkinPack) {
  skinPacks[pack.id] = pack;
}

export function getSkinPack(skinId = 'classic'): SkinPack {
  return skinPacks[skinId] ?? classicSkinPack;
}

export function listSkinPacks(): SkinPack[] {
  return Object.values(skinPacks);
}

export function resolveSprite(
  pieceValue: number,
  skinId = 'classic'
): SpriteDef | undefined {
  const pack = getSkinPack(skinId);
  return pack.pieces[pieceValue] ?? classicSkinPack.pieces[pieceValue];
}
